import { get, post } from '@/plugins/http'

export default {
  getSelfInfo: get('/live/api/v1/user/me'),
  userCreate: post('/live/api/v1/user/create'),
  getChatroomAddress: get('/live/api/v1/im/chatroom/address'),
  sendMsg: post('/live/api/v1/im/chatroom/sendmsg'),
  getMsgNum: get('/live/api/v1/im/chatroom/msgnum'),
  saveMsg: post('/live/api/v1/im/chatroom/savemsg'),
  sendGift: post('/live/api/v1/im/chatroom/sendgift'),
  // 查询课程公告
  getBroadcast: get('/live/api/v1/notice/course/latestBulletin'),
  // 获取敏感词
  getSensitive: get('/live/api/v1/im/block/word'),
}
